export default __webpack_public_path__ + "static/media/Spinner-3.b51df3f3.gif";